export const DEMO_COMPANIES_ID_STORAGE_KEY = 'demoCompaniesId';

export const DEMO_COMPANIES_ID_CHANGED_EVENT = 'cv-demo-companies-id-changed';

export type DemoCompaniesId = {
  employers: string[];
  peos: string[];
  peoPayrollProviders: string[];
};

export type DemoCompanyEntityType = keyof DemoCompaniesId;

export const EMPTY_DEMO_COMPANIES_ID: DemoCompaniesId = {
  employers: [],
  peos: [],
  peoPayrollProviders: [],
};
